import React from 'react';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "../../../../../../common/APICommon";
import EmployeePickerField from '../../../../../../common/selectComponents/EmployeePicker';

export function ThresholdApproverTab({ approvers, setApprovers, formData }) {

  const addSlot = () => setApprovers([...approvers, { approverId: "", fullName: "" }]);
  const removeSlot = (idx) => setApprovers(approvers.filter((_, i) => i !== idx));

  // // ADDED: Filter to hide already selected approvers from the picker list
  const getApproverFilter = (currentIdx) => {
    const selectedIds = approvers
      .map((a, idx) => idx !== currentIdx ? a.approverId : null)
      .filter(Boolean);

    return (employee) => !selectedIds.includes(employee.id);
  };

  return (
    <div className="space-y-4">
      <div className="border border-gray-300 rounded-lg bg-white shadow-sm">
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-100 rounded-t-lg">
          <div className="flex flex-col">
            <span className="text-xs font-bold text-blue-600 uppercase">Range Active</span>
            <h3 className="font-medium text-gray-700 text-sm">
              {Number(formData.minAmount).toLocaleString()} - {Number(formData.maxAmount).toLocaleString()}
            </h3>
          </div>
          <Button
            icon={<AddIcon fontSize="inherit" />}
            className="text-xs text-blue-500 border border-blue-300 bg-blue-50 cursor-pointer hover:bg-blue-100"
            onClick={addSlot}
            name="Add Approver"
          />
        </div>

        <div className="px-4 py-3 space-y-3">
          {approvers.map((slot, idx) => (
            <div key={idx} className="flex flex-col">
              <div className="flex items-center space-x-2">
                <span className="text-xs text-gray-400 w-5 text-right font-bold">{idx + 1}.</span>
                <div className="flex-1">
                  <EmployeePickerField
                    employeePersonalInformationId={slot.approverId}
                    displayValue={slot.fullName || ""}
                    onSelect={(emp) => {
                      const updated = [...approvers];
                      updated[idx] = { approverId: emp.id, fullName: emp.fullName };
                      setApprovers(updated);
                    }}
                    onClear={() => {
                      const updated = [...approvers];
                      updated[idx] = { approverId: "", fullName: "" };
                      setApprovers(updated);
                    }}
                    compact={true}
                    placeholder="Select Unique Approver"
                    // // MODIFIED: Added filter to prevent duplicate selection
                    filterFunction={getApproverFilter(idx)}
                  />
                </div>
                {approvers.length > 1 && (
                  <button onClick={() => removeSlot(idx)} className="text-red-400 hover:text-red-600 border-none bg-transparent cursor-pointer p-1">
                    <DeleteIcon fontSize="small" />
                  </button>
                )}
              </div>
            </div>
          ))}
          <p className="text-[11px] text-blue-500 italic mt-2 font-bold uppercase">
            * Note: Each approver can only be assigned once per threshold range.
          </p>
        </div>
      </div>
    </div>
  );
}